import { handleAdClick } from "./ad_click"
import { iabStandardFlexibleAdSizesCallback } from "./standard_ad_sizing"
import { updateAdContainerHeight } from "./update_container_height"
import { updateThemeTag } from "./update_theme_tag"

export const registerListenersForEventsInsideAds = () => {
  window.googletag.cmd.push(() => {
    handleEventsFromInsideAd('click', handleAdClick)
    handleEventsFromInsideAd('iabStandardFlexibleAdSizes', iabStandardFlexibleAdSizesCallback)
    handleEventsFromInsideAd('resize-carwow-google-ad', updateAdContainerHeight)
    handleEventsFromInsideAd('carwow-update-theme-color', updateThemeTag)
  })
}

/*
This function will register an eventListener for postMessage events sent from inside ad native code.
Provide a callback function that will receive any message events of EventType, and any arguments you
want to pass into the callback (after the message event)
*/
export const handleEventsFromInsideAd = (eventType, callback, ...callbackArguments) => {
  window.addEventListener('message', (message) => {
    if (message.data?.eventType === eventType) {
      callback(message, callbackArguments)
    }
  }, false)
}
